/**
 * Theme Configuration
 * Uses design tokens from Figma design system
 */
import {
  lightTheme as lightTokens,
  darkTheme as darkTokens,
  spacing,
  borderRadius,
  typography,
  fontFamily,
  fontWeight,
  fontSize,
  lineHeight,
  sizes,
  transitions,
  zIndex,
  breakpoints,
  media,
} from '../../theme/tokens';

// Base theme with shared values
const baseTheme = {
  fonts: {
    mono: fontFamily.mono,
    primary: fontFamily.primary,
    secondary: fontFamily.secondary,
  },
  fontWeight,
  fontSize,
  lineHeight,
  typography,
  spacing,
  borderRadius,
  sizes,
  transitions,
  zIndex,
  breakpoints,
  media,
};

// Light theme - matches Figma light mode (node-id=1-6658)
const lightTheme = {
  ...baseTheme,
  colors: {
    // Legacy mappings (for backward compatibility)
    background: lightTokens.colors.bgContainer,
    heading: lightTokens.colors.info,
    text: lightTokens.colors.infoSecondary,
    preFormattedText: lightTokens.colors.bgSurface,
    link: lightTokens.colors.primary,

    // New token-based colors
    primary: lightTokens.colors.primary,
    bg: lightTokens.colors.bg,
    bgContainer: lightTokens.colors.bgContainer,
    bgBox: lightTokens.colors.bgBox,
    bgSurface: lightTokens.colors.bgSurface,
    bgGreyContainer: lightTokens.colors.bgGreyContainer,
    border: lightTokens.colors.border,
    borderSecondary: lightTokens.colors.borderSecondary,
    info: lightTokens.colors.info,
    infoSecondary: lightTokens.colors.infoSecondary,
    infoTertiary: lightTokens.colors.infoTertiary,
    infoQuaternary: lightTokens.colors.infoQuaternary,
    linkHover: lightTokens.colors.linkHover,
    codeBackground: lightTokens.colors.codeBackground,
    codeText: lightTokens.colors.codeText,
    tableRowAlt: lightTokens.colors.tableRowAlt,
    tableBorder: lightTokens.colors.tableBorder,
    diffAddBg: lightTokens.colors.diffAddBg,
    diffAddText: lightTokens.colors.diffAddText,
    diffRemoveBg: lightTokens.colors.diffRemoveBg,
    diffRemoveText: lightTokens.colors.diffRemoveText,
  },
  shadows: lightTokens.shadows,
};

// Dark theme - matches Figma dark mode (node-id=1-6659)
const darkTheme = {
  ...baseTheme,
  colors: {
    // Legacy mappings (for backward compatibility)
    background: darkTokens.colors.bgContainer,
    heading: darkTokens.colors.info,
    text: darkTokens.colors.infoSecondary,
    preFormattedText: darkTokens.colors.bgSurface,
    link: darkTokens.colors.primary,

    // New token-based colors
    primary: darkTokens.colors.primary,
    bg: darkTokens.colors.bg,
    bgContainer: darkTokens.colors.bgContainer,
    bgBox: darkTokens.colors.bgBox,
    bgSurface: darkTokens.colors.bgSurface,
    bgGreyContainer: darkTokens.colors.bgGreyContainer,
    border: darkTokens.colors.border,
    borderSecondary: darkTokens.colors.borderSecondary,
    info: darkTokens.colors.info,
    infoSecondary: darkTokens.colors.infoSecondary,
    infoTertiary: darkTokens.colors.infoTertiary,
    infoQuaternary: darkTokens.colors.infoQuaternary,
    linkHover: darkTokens.colors.linkHover,
    codeBackground: darkTokens.colors.codeBackground,
    codeText: darkTokens.colors.codeText,
    tableRowAlt: darkTokens.colors.tableRowAlt,
    tableBorder: darkTokens.colors.tableBorder,
    diffAddBg: darkTokens.colors.diffAddBg,
    diffAddText: darkTokens.colors.diffAddText,
    diffRemoveBg: darkTokens.colors.diffRemoveBg,
    diffRemoveText: darkTokens.colors.diffRemoveText,
  },
  shadows: darkTokens.shadows,
};

export { lightTheme, darkTheme };

// Re-export tokens for direct access if needed
export {
  spacing,
  borderRadius,
  typography,
  fontFamily,
  fontWeight,
  fontSize,
  lineHeight,
  sizes,
  transitions,
  zIndex,
  breakpoints,
  media,
} from '../../theme/tokens';
